import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { isImmutable, List, Range } from 'immutable';
import { fetchForm } from '../../../apis';
import { defineKqlQuery } from '../../../helpers';
export var filterDataSources = function filterDataSources(_ref) {
  var formSlug = _ref.formSlug;
  return {
    form: {
      fn: fetchForm,
      params: [{
        datastore: true,
        formSlug: formSlug,
        include: 'indexDefinitions'
      }],
      transform: function transform(result) {
        return result.form;
      }
    },
    indexOptions: {
      fn: function fn(form) {
        return form.get('indexDefinitions').map(function (indexDefinition) {
          return {
            label: indexDefinition.get('name'),
            value: indexDefinition.get('name')
          };
        }).toArray();
      },
      params: function params(_ref2) {
        var form = _ref2.form;
        return form && [form];
      }
    },
    maxLength: {
      fn: function fn(form) {
        return form.get('indexDefinitions').map(function (indexDefinition) {
          return indexDefinition.get('parts').size;
        }).max();
      },
      params: function params(_ref3) {
        var form = _ref3.form;
        return form && [form];
      }
    },
    selectedIndexDefinition: {
      fn: function fn(form, index) {
        return form.get('indexDefinitions').find(function (indexDefinition) {
          return indexDefinition.get('name') === index;
        });
      },
      params: function params(_ref4) {
        var form = _ref4.form,
            values = _ref4.values;
        return values && [form, values.get('index')];
      }
    }
  };
};

var getOperatorIndex = function getOperatorIndex(name) {
  var match = name.match(/op(\d+)-operator/);
  return match && parseInt(match[1]);
};

var indexChangeFn = function indexChangeFn(_ref5, _ref6) {
  var maxLength = _ref5.maxLength,
      values = _ref5.values;
  var setValue = _ref6.setValue;
  Range(0, maxLength).map(function (i) {
    return "op".concat(i, "-operator");
  }).filter(function (name) {
    return !!values.get(name);
  }).forEach(function (name) {
    return setValue(name, '');
  });
};

var operatorChangeFn = function operatorChangeFn(i) {
  return function (_ref7, _ref8) {
    var values = _ref7.values;
    var setValue = _ref8.setValue;
    var value = values.get("op".concat(i, "-operator")); // If the operator was set to something besides 'eq' or 'in' clear any
    // operators after this. Their change events will then fire and clear the
    // corresponding operands.

    if (!['equals', 'in'].includes(value)) {
      values.filter(function (value, name) {
        return getOperatorIndex(name) > i;
      }).forEach(function (_value, name) {
        return setValue(name, '');
      });
    } // If the operator was set to '' and the first operand is set, clear it.


    if (!value && values.get("op".concat(i, "-operand1"))) {
      setValue("op".concat(i, "-operand1"), '');
    } // If the operator is not 'bt' and the second operand is set, clear it.


    if (value !== 'between' && values.get("op".concat(i, "-operand2"))) {
      setValue("op".concat(i, "-operand2"), '');
    } // If the operator is not 'in and the third operand is set, clear it.


    if (value !== 'in' && !values.get("op".concat(i, "-operand3")).isEmpty()) {
      setValue("op".concat(i, "-operand3"), List());
    }
  };
};

var enabledFn = function enabledFn(i) {
  return function (_ref9) {
    var values = _ref9.values;
    return Range(0, i, -1).map(function (i) {
      return values.get("op".concat(i, "-operator"));
    }).every(function (value) {
      return ['equals', 'in'].includes(value);
    });
  };
};

var visibleFn = function visibleFn(i, operatorType) {
  return function (_ref10) {
    var selectedIndexDefinition = _ref10.selectedIndexDefinition,
        values = _ref10.values;
    return selectedIndexDefinition && i < selectedIndexDefinition.get('parts').size && (!operatorType || values.get("op".concat(i, "-operator")) === operatorType);
  };
};

var serializeQuery = function serializeQuery(_ref11) {
  var selectedIndexDefinition = _ref11.selectedIndexDefinition,
      values = _ref11.values;
  return {
    index: values.get('index'),
    parts: selectedIndexDefinition.get('parts').reduce(function (reduction, part, i) {
      var operator = values.get("op".concat(i, "-operator"));
      var rValues = operator === 'between' ? [values.get("op".concat(i, "-operand1")), values.get("op".concat(i, "-operand2"))] : operator === 'in' ? [values.get("op".concat(i, "-operand3"))] : [values.get("op".concat(i, "-operand1"))];
      return reduction.push(List([part, operator].concat(rValues)));
    }, List()).filter(function (part) {
      return !part.some(function (term) {
        return isImmutable(term) && term.isEmpty() || term.length === 0;
      });
    }),
    q: selectedIndexDefinition.get('parts').reduce(function (query, part, i) {
      var op = values.get("op".concat(i, "-operator"));
      return op === 'between' ? query.between(part, "op".concat(i, "-operand1"), "op".concat(i, "-operand2")) : op === 'in' ? query["in"](part, "op".concat(i, "-operand3")) : op ? query[op](part, "op".concat(i, "-operand1")) : query;
    }, defineKqlQuery()).end()(values.toJS())
  };
};

export var filters = function filters() {
  return function (_ref12) {
    var form = _ref12.form,
        indexOptions = _ref12.indexOptions,
        maxLength = _ref12.maxLength;
    return form && indexOptions && maxLength && [{
      label: 'Search By',
      initialValue: indexOptions.first().get('value'),
      name: 'index',
      onChange: indexChangeFn,
      options: indexOptions,
      "transient": true,
      type: 'select'
    }].concat(_toConsumableArray(Range(0, maxLength).flatMap(function (i) {
      return [{
        enabled: enabledFn(i),
        name: "op".concat(i, "-operator"),
        type: 'select',
        visible: visibleFn(i),
        onChange: operatorChangeFn(i),
        options: [{
          label: '=',
          value: 'equals'
        }, {
          label: 'in',
          value: 'in'
        }, {
          label: '>',
          value: 'greaterThan'
        }, {
          label: '>=',
          value: 'greaterThanOrEquals'
        }, {
          label: '<',
          value: 'lessThan'
        }, {
          label: '<=',
          value: 'lessThanOrEquals'
        }, {
          label: 'between',
          value: 'between'
        }, {
          label: 'startsWith',
          value: 'startsWith'
        }],
        "transient": true
      }, {
        enabled: enabledFn(i),
        name: "op".concat(i, "-operand1"),
        "transient": true,
        type: 'text',
        visible: visibleFn(i)
      }, {
        enabled: enabledFn(i),
        name: "op".concat(i, "-operand2"),
        "transient": true,
        type: 'text',
        visible: visibleFn(i, 'between')
      }, {
        enabled: enabledFn(i),
        name: "op".concat(i, "-operand3"),
        "transient": true,
        type: 'text-multi',
        visible: visibleFn(i, 'in')
      }];
    }).toArray()), [{
      name: 'query',
      type: null,
      serialize: serializeQuery
    }]);
  };
};